import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-details-form',
  templateUrl: './training-details-form.component.html',
  styleUrls: ['./training-details-form.component.css']
})
export class TrainingDetailsFormComponent implements OnInit {
  title="Training Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/training-details/training-details-form/training-details-form.component.ts